import { createContext, useState, useEffect } from "react";
import axiosInstance from "../services/axiosInstance";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAuthLoading, setIsAuthLoading] = useState(true);

  useEffect(() => {
      axiosInstance
        .get("/auth/verify_token")
        .then((res) => {
          setUser(res.data.user);
        })
        .catch((error) => { 
          setUser(null)
        })
        .finally(() => setIsAuthLoading(false));
  }, []);

  const setAuthUser = (user) => {
    setUser(user);
  };

  const signOut = async () => {
    try { await axiosInstance.post("/auth/signout"); }
    finally { setUser(null); }
  };

  return (
    <AuthContext.Provider value={{ user, setAuthUser, signOut, isAuthLoading }}>
      {children}
    </AuthContext.Provider>
  );
};

export { AuthContext, AuthProvider };
